// extracted by mini-css-extract-plugin
module.exports = {"card-modal":"CardModal_card-modal__cxsqy"};